import { createSlice } from '@reduxjs/toolkit'

import { SubwayState } from './types'
import { fetchDestinations } from './subwayThunk'

const initialState: SubwayState = {
  destinations: null,
  loading: false,
  error: null,
}

const subwaySlice = createSlice({
  name: 'subway',
  initialState,
  reducers: {
    clear: (state) => {
      state.destinations = null
      state.error = null
      state.loading = false
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDestinations.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDestinations.fulfilled, (state, action) => {
        state.loading = false
        state.destinations = action.payload
      })
      .addCase(fetchDestinations.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { clear } = subwaySlice.actions

export default subwaySlice.reducer
